module.exports = __webpack_public_path__ + "img/about-02.ccbeaf1a.png";